import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDeskOffice"><Path fillRule="evenodd" clipRule="evenodd" d="M2 5H22V19H10V7H4V19H2V5ZM16 9V12H14V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDeskOffice;
